import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

export abstract class StructureBackgroundColorBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.STRUCTURE].BACKGROUND_COLOR;
  }
}
